"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

require('./BuyInCreditModalView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BuyInCreditModalView: {
        displayName: 'BuyInCreditModalView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/BuyInCreditModal/default/BuyInCreditModalView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var BuyInCreditModalView = _wrapComponent('BuyInCreditModalView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(BuyInCreditModalView, _Component);

    function BuyInCreditModalView(props) {
        (0, _classCallCheck3.default)(this, BuyInCreditModalView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BuyInCreditModalView.__proto__ || (0, _getPrototypeOf2.default)(BuyInCreditModalView)).call(this, props));

        _this.state = {
            countForSendBasket: 1
        };
        return _this;
    }

    (0, _createClass3.default)(BuyInCreditModalView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var discountEpsilon = this.props.order_detail.discount_sum;
            var discountPercent = this.props.order_detail.discount_sum / (this.props.order_detail.sum / 100);
            return _react3.default.createElement(
                'div',
                { className: 'text-center' },
                _react3.default.createElement(
                    'form',
                    { action: this.props.creditUrl, method: 'post' },
                    _react3.default.createElement('input', { name: 'shopId', value: this.props.buy_in_credit.external_shop_id, type: 'hidden' }),
                    _react3.default.createElement('input', { name: 'promoCode', value: this.props.buy_in_credit.promo_code === '' ? 'default' : this.props.buy_in_credit.promo_code, type: 'hidden' }),
                    _react3.default.createElement('input', { name: 'sum', value: parseFloat(this.props.order_detail.sum - this.props.order_detail.discount_sum).toFixed(2), type: 'hidden' }),
                    _react3.default.createElement('input', { name: 'orderNumber', value: this.props.order_detail.order_number, type: 'hidden' }),
                    this.props.order_detail.products.map(function (item, index) {
                        var modifierOptionName = '';
                        var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
                        var price = parseFloat(item.base_price - sale).toFixed(2);
                        discountEpsilon = discountEpsilon - sale * item.quantity;
                        if (item.modifier_option_name !== null) {
                            modifierOptionName = item.modifier_option_name;
                        }
                        if (index === _this2.props.order_detail.products.length) {
                            price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
                        }
                        return _react3.default.createElement(
                            'div',
                            { key: index },
                            _react3.default.createElement('input', { name: 'itemName_' + index, value: item.name + modifierOptionName, type: 'hidden' }),
                            _react3.default.createElement('input', { name: 'itemQuantity_' + index, value: item.quantity, type: 'hidden' }),
                            _react3.default.createElement('input', { name: 'itemPrice_' + index, value: price, type: 'hidden' }),
                            _react3.default.createElement('input', { name: 'itemVendorCode_' + index, value: item.id_yml, type: 'hidden' })
                        );
                    }),
                    _react3.default.createElement('input', { name: 'customerNumber', value: this.props.user.id, type: 'hidden' }),
                    _react3.default.createElement('input', { name: 'customerEmail', value: this.props.user.email, type: 'hidden' }),
                    _react3.default.createElement('input', { name: 'customerPhone', value: this.props.user.phone, type: 'hidden' }),
                    _react3.default.createElement('input', { type: 'submit', className: 'le-button big pay_order_button button_width_100', value: this.props.title })
                )
            );
        }
    }]);
    return BuyInCreditModalView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object.isRequired,
    currency: _react2.PropTypes.object.isRequired
}, _temp));

exports.default = BuyInCreditModalView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/BuyInCreditModal/default/BuyInCreditModalView.jsx
// module id = 1615
// module chunks = 0